module.exports = __webpack_public_path__ + "img/anli05.5c24ba08.png";